import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStatusLog = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 42,
	height: 42,
	viewBox: "0 0 42 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 21,
			cy: 21.0039,
			r: 21,
			fill: "#F0EEFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17 11.0039V14.0039",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25 11.0039V14.0039",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.2 30.4039C28.9673 30.4039 30.4 28.9712 30.4 27.2039C30.4 25.4366 28.9673 24.0039 27.2 24.0039C25.4327 24.0039 24 25.4366 24 27.2039C24 28.9712 25.4327 30.4039 27.2 30.4039Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31 31.0039L30 30.0039",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.5 18.0938H29.5",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.37 31.0039H17C13.5 31.0039 12 29.0039 12 26.0039V17.5039C12 14.5039 13.5 12.5039 17 12.5039H25C28.5 12.5039 30 14.5039 30 17.5039V22.0039",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.9945 22.7031H21.0035",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.2953 22.7031H17.3043",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.2953 25.7031H17.3043",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgStatusLog;
